const options = {
  5: "bg-lime-200/5",
  10: "bg-lime-200/10",
  25: "bg-lime-200/25",
  50: "bg-lime-200/50",
  75: "bg-lime-200/75",
  90: "bg-lime-200/90",
  100: "bg-lime-200",
};

const from = {
  5: "from-lime-200/5",
  10: "from-lime-200/10",
  25: "from-lime-200/25",
  50: "from-lime-200/50",
  75: "from-lime-200/75",
  90: "from-lime-200/90",
  100: "from-lime-200",
};

export default function getBackgroundLime200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
